import { Component, OnInit, OnDestroy, OnChanges } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';

import { Simulation } from '@classes/simulation/simulation';
import { KpiByYear } from '@classes/simulation/kpi-by-year';
import { NavLink } from '@classes/nav-link';
import { SimulationService } from '@services/simulation.service';
import { NavService } from '@services/nav.service';

@Component({
    selector: 'app-live',
    templateUrl: './live.component.html',
    styleUrls: ['./live.component.scss']
})
export class LiveComponent implements OnInit, OnChanges, OnDestroy {
    private selectedSimulationSub: Subscription;
    private selectedYearSub: Subscription;

    simulation: Simulation;
    selectedYear: KpiByYear;
    links: NavLink[];

    constructor(
        private route: ActivatedRoute,
        private simulationSrv: SimulationService,
        private navSrv: NavService
    ) { }

    ngOnInit() {
        // TODO: Get links
        // this.links = this.navSrv.getNavLinks(['/advanced', '/investment']);
        this.initSubscriptions();
    }
    ngOnChanges() {
        // TODO: Get links
        // this.links = this.navSrv.getNavLinks(['/advanced', '/investment']);
        this.initSubscriptions();
    }

    private initSubscriptions(): void {
        const year = new Date().getFullYear();

        this.route.data
        .subscribe(data => {
            this.simulation = data.simulation;
            this.selectedYear = this.simulation.kpisByYear.find(k => k.year === year);
            if (!this.selectedYear)
            {
                const years = this.simulation.kpisByYear;
                this.selectedYear = years && years.length ? years[years.length - 1] : null;
            }
        });

        this.selectedSimulationSub = this.simulationSrv.selectedSimulationChanged
        .subscribe(simulation => {
            this.simulation = simulation;
            if(simulation) {
                this.selectedYear = this.simulation.kpisByYear.find(k => k.year === year);
                if (!this.selectedYear)
                {
                    const years = this.simulation.kpisByYear;
                    this.selectedYear = years && years.length ? years[years.length - 1] : null;
                }
            }
        });

        this.selectedYearSub = this.simulationSrv.selectedYearChanged
        .subscribe(selectedYear => {
            this.selectedYear = this.simulation.kpisByYear.find(k => k.year === selectedYear);
        });
    }

    ngOnDestroy() {
        if(this.selectedSimulationSub) {
            this.selectedSimulationSub.unsubscribe();
        }
        if(this.selectedYearSub) {
            this.selectedYearSub.unsubscribe();
        }
    }
}
